import type { CallReason } from "@expert/app-config/types";
import type { ComboboxData } from "@mantine/core";
import type { JSX } from "react";

import { Select, Text } from "@mantine/core";

interface CallReasonInputProps {
    callReasons: CallReason[];
    onChange?: (callReason: { reason?: string; subReason?: string }) => void;
}

const SEPARATOR = " | ";

export function CallReasonInput({ callReasons, onChange }: CallReasonInputProps): JSX.Element | null {
    const data: ComboboxData = callReasons.map((callReason) => {
        if (callReason.subReasons) {
            return {
                group: callReason.reason,
                items: callReason.subReasons.map((subReason) => ({
                    value: `${callReason.reason}${SEPARATOR}${subReason}`,
                    label: subReason,
                })),
            };
        } else {
            return callReason.reason;
        }
    });

    return (
        <Select
            label={
                <Text size="sm" pb="xs">
                    Call reason
                </Text>
            }
            placeholder="Choose an option"
            data={data}
            variant="filled"
            pb="md"
            searchable
            styles={{ dropdown: { zIndex: "var(--mantine-priority-highest)" } }}
            onChange={(_value, option) => {
                if (!option) {
                    onChange?.({});
                    return;
                }
                const [reason, subReason] = option.value.split(SEPARATOR);
                onChange?.({ reason, subReason });
            }}
            clearable
        />
    );
}
